module.exports = __webpack_public_path__ + "ras_icon_white.svg?fea4a34e132ca51881bdb85648c57b4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ras_icon_white.svg
// module id = 1130
// module chunks = 2